import {
    getProjects,
    updateProject,
    createProject,
    saveSelectedLeads as saveSelectedLeadsAgent,
    deleteProject as deleteProjectAgent,
} from './agent';

import type { TUpdateTProject } from 'src/types/Projects';

class ProjectsService {
    queryKey = 'projects';

    getProjects = async () => {
        try {
            const { data } = await getProjects();

            return Promise.resolve(data);
        } catch (error) {
            return Promise.reject(error);
        }
    };

    createProject = async (project: TUpdateTProject) => {
        try {
            const { data } = await createProject(project);

            return Promise.resolve(data);
        } catch (err) {
            return Promise.reject(err);
        }
    };

    updateProject = async (project: TUpdateTProject) => {
        try {
            const { data } = await updateProject(project);

            return Promise.resolve(data);
        } catch (error) {
            return Promise.reject(error);
        }
    };

    saveSelectedLeads = async (projectId: number, selectedLeadIds: number[]) => {
        try {
            const { data } = await saveSelectedLeadsAgent(projectId, selectedLeadIds);

            return Promise.resolve(data);
        } catch (error) {
            return Promise.reject(error);
        }
    };

    deleteProject = async (id: number) => {
        try {
            console.log('ProjectsService.deleteProject вызван для id:', id);
            await deleteProjectAgent(id);
            console.log('deleteProjectAgent выполнен успешно');

            return Promise.resolve();
        } catch (error) {
            console.error('Ошибка в ProjectsService.deleteProject:', error);
            return Promise.reject(error);
        }
    };
}

export default new ProjectsService();
